<template>
  <v-container fluid class="d-flex flex-column justify-center height-100-percent">
    <v-row align-content="center">
      <v-col
          cols="12"
          sm="10" offset-sm="1"
          md="8" offset-md="2"
          lg="6" offset-lg="3"
          xl="4" offset-xl="4"
      >
        <v-card elevation="1">
          <v-card-title>
            <img src="/images/acc-logo-rgb.png" alt="America's Call Center" height="100" width="157"
                 class="mx-auto">
          </v-card-title>
          <v-card-text>
            <p class="mt-10 text-body-1 text-center">Please check your email for a link to reset your password.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AppForgotPasswordSent"
}
</script>